export const subtitleOptions = [
	{
		color: '#8CF07E',
		title: 'Introducción a la NOM 035',
	},
	{
		color: '#1AB0E6',
		title: 'Sensibilización',
	},
	{
		color: '#5082C2',
		title: 'Evaluación',
	},
	{
		color: '#C22A58',
		title: 'Cierre de evaluación',
	},
];
